import { render, staticRenderFns } from "./TagField.vue?vue&type=template&id=01f6c774&scoped=true"
import script from "./TagField.vue?vue&type=script&lang=js"
export * from "./TagField.vue?vue&type=script&lang=js"
import style0 from "./TagField.vue?vue&type=style&index=0&id=01f6c774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f6c774",
  null
  
)

export default component.exports